import styled from 'styled-components';

import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';

const Container = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${space(6)} 0;

  ${media.min('medium')`
    padding: ${space(8)} 0;
  `}
`;

const Top = styled.div`
  text-align: center;

  .description {
    margin-top: ${space(4)};
  }

  &:first-child {
    margin-top: 0;
  }
`;

const Bottom = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Card = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: ${space(6)};
  max-width: ${rems(264)};
  text-align: center;
  width: 100%;

  &.pointer {
    cursor: pointer;
  }

  .icon {
    ${fonts.bodySM};
    height: ${rems(100)};
    margin-bottom: ${space(2)};
    width: ${rems(100)};
  }

  .title-card {
    ${fonts.bodyLG};
    margin-bottom: ${space(1)};
  }

  .description-card {
    ${fonts.bodySM};
    padding: 0;
  }

  ${media.min('medium')`
    margin-top: ${space(8)};
    max-width: none;
    min-width: ${rems(248)};
    padding: 0 ${space(2)};
    width: 25%;

    &:first-child:nth-last-child(5),
    &:first-child:nth-last-child(5) ~ & {
      width: 33%;

      .description-card {
        max-width: ${rems(300)};
      }
    }

    .icon {
        margin-bottom: ${space(3)};
    }
  `}
`;

export { Container, Top, Bottom, Card };
